import type { ReactNode } from "react";
import { Link } from "react-router";
import { Avatar } from "./Avatar";

// Eine Person in einer Zeile: Bild, Name, und beides führt aufs Profil.
//
// Warum als eigener Baustein und nicht dreimal von Hand: dieselbe Zeile steht
// inzwischen an vielen Stellen, und jedes Mal hat sie dieselben drei Fragen -
// welche Größe hat das Bild, wohin führt der Klick, und was passiert ohne Id.
// Genau dafür ist ein Primitive da. Die Route `/p/:id` ist die fremde
// Profilseite (router.tsx), nicht `/save/basics`, das ist die eigene.
//
// Ohne `id` wird nicht verlinkt, statt einen toten Klick anzubieten: Personen
// ohne Id gibt es wirklich, etwa importierte Namen ohne Konto.

export interface PersonLinkPerson {
  id?: string | null;
  name: string;
  avatarContent?: string | null;
  avatarMime?: string | null;
}

export function PersonLink({
  person,
  id,
  size = "sm",
  className = "",
  secondary,
}: {
  person: PersonLinkPerson;
  id?: string;
  size?: "sm" | "md" | "lg";
  className?: string;
  secondary?: ReactNode;
}) {
  const body = (
    <>
      <Avatar person={person} size={size} />
      <span className="min-w-0">
        <span className="block truncate">{person.name}</span>
        {secondary && <span className="block truncate text-smycles-meta text-ink-muted">{secondary}</span>}
      </span>
    </>
  );

  const shared = `inline-flex min-w-0 items-center gap-2 ${className}`;

  if (!person.id) {
    return <span id={id} className={shared}>{body}</span>;
  }

  return (
    <Link id={id} to={`/p/${person.id}`} className={`${shared} transition hover:text-ink`}>
      {body}
    </Link>
  );
}
